import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-text-italic",
  "use": "foquz-icon-text-italic-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol viewBox=\"0 0 16 18\" fill=\"none\" id=\"foquz-icon-text-italic\"><path d=\"M15 1H6m4 16H1M11 1L5 17\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol